import { render, staticRenderFns } from "./StackingAutomation.vue?vue&type=template&id=43d8be52&scoped=true&"
import script from "./StackingAutomation.vue?vue&type=script&lang=js&"
export * from "./StackingAutomation.vue?vue&type=script&lang=js&"
import style0 from "./StackingAutomation.vue?vue&type=style&index=0&id=43d8be52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d8be52",
  null
  
)

export default component.exports